import { CustomerEntity } from 'types/CustomerEntity'
import ApiBase from './Api'

const ADMIN_CUSTOMER_API_PATHS = {
    ALL_CUSTOMERS: '/admin/customers',
    CUSTOMER_DETAILS: (id: string) => `/admin/customers/${id}`,
    UPDATE_CUSTOMER: (id: string) => `/admin/customers/${id}`,
}

class CustomerApi extends ApiBase {
    adminAllCustomers() {
        return this._getRequest<CustomerEntity[]>(ADMIN_CUSTOMER_API_PATHS.ALL_CUSTOMERS)
    }

    async createCustomer(name: string) {
        return this._postRequest(ADMIN_CUSTOMER_API_PATHS.ALL_CUSTOMERS, { name })
    }

    getCustomer(id: string) {
        return this._getRequest(ADMIN_CUSTOMER_API_PATHS.CUSTOMER_DETAILS(id))
    }

    async updateCustomer(id: string, data: Record<string, unknown>) {
        // removed id from the data

        const { id: _, ...restOfData } = data
        return this._putRequest(`${ADMIN_CUSTOMER_API_PATHS.UPDATE_CUSTOMER(id)}`, restOfData)
    }
}

export default CustomerApi
